// eslint-disable-next-line no-shadow
enum locationKeys {
  initial = 'scip_startLocation',
  last = 'scip_lastLocation' // Perhaps we will save the last page before/when pressing logout?
}

(function setInitialRedirectUrl() {
  const initialUri = window.location.href.replace(location.origin, '').replace('/scip-ui/', '');
  // We only set the initial url once per session because the redirect url is hardcoded (currently)
  if (!sessionStorage.getItem(locationKeys.initial)?.length) {
    sessionStorage.setItem(locationKeys.initial, initialUri);
  }
})();

export const redirectUrlHandler = {
  getRedirectUrl: (): string => {
    return sessionStorage.getItem(locationKeys.initial);
  },
  clearInitialUrl: (): void => {
    sessionStorage.removeItem(locationKeys.initial);
  }
};
